import styled, { CSSObject } from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const StyledHeader = styled.th(
  (props: { width?: CSSObject['width']; textAlign?: CSSObject['textAlign'] }) =>
    mq({
      width: props.width,
      fontSize: defaultTheme.font.size.xs,
      fontWeight: 'inherit',
      lineHeight: defaultTheme.font.height.base,
      backgroundColor: defaultTheme.background.mediumGray,
      verticalAlign: 'middle',
      textAlign: props.textAlign || 'center',
      whiteSpace: 'nowrap',
      '& > .wrapper': {
        display: 'block',
        height: '99%',
        borderRight: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
        padding: `${defaultTheme.spacing.s} 0`,
      },
    }),
);
